export default __webpack_public_path__ + "c289cac5740c15bb02dd2e132e7bd3c6.png";